import React from "react"
import "./footer.scss"
import { useTranslation } from 'react-i18next'
import { useNavigate } from "react-router-dom"

const footerLinks = [
  { text: 'about', path: '/about' },
  { text: 'rooms', path: '/rooms' },
  { text: 'services', path: '/services' },
  { text: 'gallery', path: '/gallery' },
  { text: 'contact us', path: '/contact' },
]

const Footer = () => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()

  const goTo = (path: string) => {
    navigate(path)
    window.scrollTo(0, 0)
  }

  return (
    <footer className='footer'>
      <div className='container'>
        <div className='footer__inner'>
          <div className='footer__logo'>
            <img src='/images/logo.png' alt="Château Le Corvier" />
            <span className='footer__logo-name'>Château Le Corvier</span>
          </div>

          <div className='footer__links'>
            {footerLinks.map((link) => (
              <a key={link.path} onClick={() => goTo(link.path)}>{t(link.text)}</a>
            ))}
          </div>

          <span className='footer__rule' />

          <p className='footer__copy'>
            {t('Official website of Château Le Corvier, a service provided by AuCoeur Service. © Designed by Helixion.')}
          </p>

          <a className='footer__legal' onClick={() => goTo('/legal')}>
            {t('Legal Mentions & Privacy Policy')}
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
